import {
  Container,
  Stack,
  Text,
  Box,
  Heading,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react';
import React from 'react';
import Footer from '../components/footer';
import Nav from '../components/navbar';

export const PrivacyPolicy = () => {
  return (
    <>
      <Nav />
      <Container maxW={'6xl'}>
        <Stack
          as={Box}
          spacing={{ base: 10, md: 14 }}
          py={{ base: 10, md: 20 }}
        >
          <Heading
            as="h1"
            color={'green.500'}
            textAlign={'center'}
            fontWeight={600}
            fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
            id="heading"
          >
            Privacy Policy for HowLongism
          </Heading>
        </Stack>
        <Stack
          spacing={{ base: 4, md: 6 }}
          fontSize={{ base: '16px', sm: '16px', md: '18px' }}
          textAlign="justify"
          pb={{ base: 10, md: 20 }}
        >
          <Text>
            At HowLongism, accessible from https://www.howlongism.com, one of
            our main priorities is the privacy of our visitors. This Privacy
            Policy document contains types of information that is collected and
            recorded by HowLongism and how we use it.
          </Text>

          <Text>
            If you have additional questions or require more information about
            our Privacy Policy, do not hesitate to contact us.
          </Text>

          <Text>
            This Privacy Policy applies only to our online activities and is
            valid for visitors to our website with regards to the information
            that they shared and/or collect in HowLongism. This policy is not
            applicable to any information collected offline or via channels
            other than this website.
          </Text>
          <Heading
            as="h2"
            color={'green.500'}
            textAlign={'center'}
            fontWeight={600}
            fontSize={{ base: '2xl', sm: '3xl', md: '5xl' }}
            id="heading"
          >
            Consent
          </Heading>
          <Text>
            By using our website, you hereby consent to our Privacy Policy and
            agree to its terms.
          </Text>

          <Heading
            as="h2"
            color={'green.500'}
            textAlign={'center'}
            fontWeight={600}
            fontSize={{ base: '2xl', sm: '3xl', md: '5xl' }}
            id="heading"
          >
            Information we collect
          </Heading>

          <Text>
            The personal information that you are asked to provide, and the
            reasons why you are asked to provide it, will be made clear to you
            at the point we ask you to provide your personal information.
          </Text>
          <Text>
            If you contact us directly, we may receive additional information
            about you such as your name, email address, phone number, the
            contents of the message and/or attachments you may send us, and any
            other information you may choose to provide.
          </Text>
          <Text>
            When you register for an Account, we may ask for your contact
            information, including items such as name, company name, address,
            email address, and telephone number.
          </Text>
          <Heading
            as="h2"
            color={'green.500'}
            textAlign={'center'}
            fontWeight={600}
            fontSize={{ base: '2xl', sm: '3xl', md: '5xl' }}
            id="heading"
          >
            How we use your information
          </Heading>

          <Text>
            We use the information we collect in various ways, including to:
          </Text>

          <UnorderedList>
            <ListItem>Provide, operate, and maintain our website</ListItem>
            <ListItem>Improve, personalize, and expand our website</ListItem>
            <ListItem>Understand and analyze how you use our website</ListItem>
            <ListItem>
              Develop new products, services, features, and functionality
            </ListItem>
            <ListItem>
              Communicate with you, either directly or through one of our
              partners, including for customer service, to provide you with
              updates and other information relating to the website, and for
              marketing and promotional purposes
            </ListItem>
            <ListItem>Send you emails</ListItem>
            <ListItem>Find and prevent fraud</ListItem>
          </UnorderedList>

          <Heading
            as="h2"
            color={'green.500'}
            textAlign={'center'}
            fontWeight={600}
            fontSize={{ base: '2xl', sm: '3xl', md: '5xl' }}
            id="heading"
          >
            Log Files
          </Heading>

          <Text>
            HowLongism follows a standard procedure of using log files. These
            files log visitors when they visit websites. All hosting companies
            do this and a part of hosting services' analytics. The information
            collected by log files include internet protocol (IP) addresses,
            browser type, Internet Service Provider (ISP), date and time stamp,
            referring/exit pages, and possibly the number of clicks. These are
            not linked to any information that is personally identifiable. The
            purpose of the information is for analyzing trends, administering
            the site, tracking users' movement on the website, and gathering
            demographic information.
          </Text>
          <Heading
            as="h2"
            color={'green.500'}
            textAlign={'center'}
            fontWeight={600}
            fontSize={{ base: '2xl', sm: '3xl', md: '5xl' }}
            id="heading"
          >
            Cookies and Web Beacons
          </Heading>

          <Text>
            Like any other website, HowLongism uses 'cookies'. These cookies are
            used to store information including visitors' preferences, and the
            pages on the website that the visitor accessed or visited. The
            information is used to optimize the users' experience by customizing
            our web page content based on visitors' browser type and/or other
            information.
          </Text>

          <Heading
            as="h2"
            color={'green.500'}
            textAlign={'center'}
            fontWeight={600}
            fontSize={{ base: '2xl', sm: '3xl', md: '5xl' }}
            id="heading"
          >
            Google DoubleClick DART Cookie{' '}
          </Heading>

          <Text>
            Google is one of a third-party vendor on our site. It also uses
            cookies, known as DART cookies, to serve ads to our site visitors
            based upon their visit to www.website.com and other sites on the
            internet. However, visitors may choose to decline the use of DART
            cookies by visiting the Google ad and content network Privacy Policy
            at the following URL –{' '}
            <a href="https://policies.google.com/technologies/ads">
              https://policies.google.com/technologies/ads
            </a>
          </Text>

          <Heading
            as="h2"
            color={'green.500'}
            textAlign={'center'}
            fontWeight={600}
            fontSize={{ base: '2xl', sm: '3xl', md: '5xl' }}
            id="heading"
          >
            Our Advertising Partners{' '}
          </Heading>

          <Text>
            Some of advertisers on our site may use cookies and web beacons. Our
            advertising partners are listed below. Each of our advertising
            partners has their own Privacy Policy for their policies on user
            data. For easier access, we hyperlinked to their Privacy Policies
            below.
          </Text>

          <UnorderedList>
            <ListItem>
              <Text>
                Google:{' '}
                <a href="https://policies.google.com/technologies/ads">
                  https://policies.google.com/technologies/ads
                </a>
              </Text>
            </ListItem>
          </UnorderedList>

          <Heading
            as="h2"
            color={'green.500'}
            textAlign={'center'}
            fontWeight={600}
            fontSize={{ base: '2xl', sm: '3xl', md: '5xl' }}
            id="heading"
          >
            Advertising Partners Privacy Policies
          </Heading>

          <Text>
            You may consult this list to find the Privacy Policy for each of the
            advertising partners of HowLongism.
          </Text>

          <Text>
            Third-party ad servers or ad networks uses technologies like
            cookies, JavaScript, or Web Beacons that are used in their
            respective advertisements and links that appear on HowLongism, which
            are sent directly to users' browser. They automatically receive your
            IP address when this occurs. These technologies are used to measure
            the effectiveness of their advertising campaigns and/or to
            personalize the advertising content that you see on websites that
            you visit.
          </Text>

          <Text>
            Note that HowLongism has no access to or control over these cookies
            that are used by third-party advertisers.
          </Text>

          <Heading
            as="h2"
            color={'green.500'}
            textAlign={'center'}
            fontWeight={600}
            fontSize={{ base: '2xl', sm: '3xl', md: '5xl' }}
            id="heading"
          >
            Third Party Privacy Policies
          </Heading>

          <Text>
            HowLongism's Privacy Policy does not apply to other advertisers or
            websites. Thus, we are advising you to consult the respective
            Privacy Policies of these third-party ad servers for more detailed
            information. It may include their practices and instructions about
            how to opt-out of certain options.{' '}
          </Text>

          <Text>
            You can choose to disable cookies through your individual browser
            options. To know more detailed information about cookie management
            with specific web browsers, it can be found at the browsers'
            respective websites.
          </Text>

          <Heading
            as="h2"
            color={'green.500'}
            textAlign={'center'}
            fontWeight={600}
            fontSize={{ base: '2xl', sm: '3xl', md: '5xl' }}
            id="heading"
          >
            CCPA Privacy Rights (Do Not Sell My Personal Information)
          </Heading>

          <Text>
            Under the CCPA, among other rights, California consumers have the
            right to:
          </Text>
          <Text>
            Request that a business that collects a consumer's personal data
            disclose the categories and specific pieces of personal data that a
            business has collected about consumers.
          </Text>
          <Text>
            Request that a business delete any personal data about the consumer
            that a business has collected.
          </Text>
          <Text>
            Request that a business that sells a consumer's personal data, not
            sell the consumer's personal data.
          </Text>
          <Text>
            If you make a request, we have one month to respond to you. If you
            would like to exercise any of these rights, please contact us.
          </Text>

          <Heading
            as="h2"
            color={'green.500'}
            textAlign={'center'}
            fontWeight={600}
            fontSize={{ base: '2xl', sm: '3xl', md: '5xl' }}
            id="heading"
          >
            GDPR Data Protection Rights
          </Heading>

          <Text>
            We would like to make sure you are fully aware of all of your data
            protection rights. Every user is entitled to the following:
          </Text>
          <Text>
            The right to access – You have the right to request copies of your
            personal data. We may charge you a small fee for this service.
          </Text>
          <Text>
            The right to rectification – You have the right to request that we
            correct any information you believe is inaccurate. You also have the
            right to request that we complete the information you believe is
            incomplete.
          </Text>
          <Text>
            The right to erasure – You have the right to request that we erase
            your personal data, under certain conditions.
          </Text>
          <Text>
            The right to restrict processing – You have the right to request
            that we restrict the processing of your personal data, under certain
            conditions.
          </Text>
          <Text>
            The right to object to processing – You have the right to object to
            our processing of your personal data, under certain conditions.
          </Text>
          <Text>
            The right to data portability – You have the right to request that
            we transfer the data that we have collected to another organization,
            or directly to you, under certain conditions.
          </Text>
          <Text>
            If you make a request, we have one month to respond to you. If you
            would like to exercise any of these rights, please contact us.
          </Text>

          <Heading
            as="h2"
            color={'green.500'}
            textAlign={'center'}
            fontWeight={600}
            fontSize={{ base: '2xl', sm: '3xl', md: '5xl' }}
            id="heading"
          >
            Children's Information
          </Heading>

          <Text>
            Another part of our priority is adding protection for children while
            using the internet. We encourage parents and guardians to observe,
            participate in, and/or monitor and guide their online activity.
          </Text>

          <Text>
            HowLongism does not knowingly collect any Personal Identifiable
            Information from children under the age of 13. If you think that
            your child provided this kind of information on our website, we
            strongly encourage you to contact us immediately and we will do our
            best efforts to promptly remove such information from our records.
          </Text>
        </Stack>
      </Container>
      <Footer />
    </>
  );
};
